export class NgxRequest {

}

export class NgxResponse {

}
